import createAsyncSlice from '../utils/createAsyncSlice';
import { fetchToken, getRefreshToken, resetTokenState } from './auth';
import { setLocalStorage } from '../utils/localStorage';
import { resetInformationsState } from './informations';
import { resetOrderItemsState } from './orderItems';
import { resetWarehousesState } from './warehouses';
import { resetLogOrdersState } from './logOrders';
import { resetAccountsState } from './accounts';
import { resetAccountState } from './account';
import { resetOrdersState } from './orders';
import { getPopup } from './popup';
import { deserializeUserToken } from '../utils/deserializeUserToken';

const user = createAsyncSlice({
  name: 'user',
  reducers:{
    setUser(state, action){
      const {payload} = action
      state.data = payload;
    }
  },
  initialState: {
    data: null,
  },
});

export const fetchUser = user.asyncAction;
export const { resetState: resetUserState } = user.actions;
export const {setUser} = user.actions;

export default user.reducer;

let cont = 0;

export const userLogin = (data) => async (dispatch) => {
  const { payload } = await dispatch(
    fetchToken({ url: '/auth/login-2fa', method: 'POST', data }),
  );

  if (payload?.accessToken && payload?.refreshToken) {
    dispatch(autoLogin({ token: payload.accessToken, refreshToken: payload.refreshToken }),)
    cont = 0;
  }
};

export const refreshToken = () => async (dispatch, getState) => {
  cont++;
  if (cont <= 1) {
    const { auth } = getState();
    const { payload } = await dispatch(
      fetchToken({
        url: '/auth/refresh-login',
        method: 'POST',
        data: {
          token: auth?.data?.token,
          refreshToken: auth?.data?.refreshToken,
        },
      }),
    );
    if (payload?.accessToken && payload?.refreshToken) {
      dispatch(
        autoLogin({ token: payload.accessToken, refreshToken: payload.refreshToken }),
      );
      cont = 0;
    } else {
      dispatch(
        getPopup({
          message: 'Usuário inativo por um longo período',
          type: 'danger',
        }),
      );
      dispatch(userLogout());
    }
  }
};

export const resetPassword = (data) => async (dispatch) => {
  const {payload} = await dispatch(fetchToken({url: '/user/change-password', method: "POST", data}));

  if(payload?.status === 401){
    dispatch(getPopup({message: "Seu token não é mais válido, refaça o login", type: 'danger',}))
    dispatch(userLogout());
    return
  }

  if (payload?.accessToken && payload?.refreshToken) {
    await dispatch(
      autoLogin({ token: payload.accessToken, refreshToken: payload.refreshToken }),
    );
  }
};

export const autoLogin = (data) => async (dispatch, getState) => {
  if (data) setLocalStorage('_tokens', data, null);
  dispatch(getRefreshToken());
  const { auth } = getState();

  if (auth?.data?.token) {
    try{
      const userData = deserializeUserToken(auth.data.token);
      dispatch(setUser(userData));
      dispatch( getPopup({ message: `Bem vindo!`, type: 'success' }),);
    }catch(error){
      dispatch(
        getPopup({
          message: error.message,
          type: 'danger',
        }),
      );
      return dispatch(userLogout());
    }    
  }
};

export const userLogout = () => (dispatch) => {
  window.localStorage.removeItem('_tokens');
  dispatch(resetTokenState());
  dispatch(getRefreshToken());
  dispatch(resetInformationsState());
  dispatch(resetOrderItemsState());
  dispatch(resetWarehousesState());
  dispatch(resetLogOrdersState());
  dispatch(resetAccountsState());
  dispatch(resetAccountState());
  dispatch(resetOrdersState());
  dispatch(resetUserState());
};
